<template>
    <v-dialog class="notifications dialog" v-model="dialog" max-width="760" origin="top top" @input="onClose">
        <v-card>
            <div class="box-title">
                <img v-if="status === 'error' && !loadingTransaction" src="~ThemePath/img/notification/error.png" />
                <v-card-title class="text text-title" v-html="getTranslatedText(title)"></v-card-title>
                <div class="box-loading" v-if="loadingTransaction">
                    <loading></loading>
                    <span>{{ getTranslatedText(textLoading) }}</span>
                </div>
                <v-card-text class="text text-des" v-if="!loadingTransaction"> {{ getTranslatedText(description) }} </v-card-text>
                <img v-if="status === 'success' && !loadingTransaction" src="~ThemePath/img/notification/success.png" />
                <b v-if="status === 'confirm' && !loadingTransaction" class="text amount">{{ getTranslatedText(amount) }}</b>
            </div>
            <v-card-actions class="box-btn">
                <ButtonCommon v-if="status === 'confirm' && !loadingTransaction" text="Confirm" class-name="btn box-btn__confirm" @action-button="onConfirmOk" :isNoHover="true" />
                <ButtonCommon :text="textBtn" class-name="btn box-btn__close" :class="{'btn_yellow': loadingTransaction || status==='success'}" @action-button="onClose" :isNoHover="false" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import languageMixins from '@/mixins/language/language-mixins'
import EventBus from '@/utils/EventBus'
import ButtonCommon from '@/components/common/button'
import Loading from '@/components/common/loading'
import { isStrEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins],
    components: { ButtonCommon, Loading },
    data() {
        return {
            dialog: false,
            title: '',
            description: '',
            amount: '',
            nameFunction: '',
            nameFunctionClose: '',
            paramFunction: null,
            status: '',
            textBtn: 'Close',
            loadingTransaction:false,
            textLoading:'processing',
            titleLoading:'',
            confirmLoading:false,
        }
    },
    created() {
        EventBus.$on('on-show-notications', (param) => {
            this.dialog = true
            this.title = param.title
            this.description = param.description
            this.amount = param.amount
            this.nameFunction = param.nameFunction
            if (param.paramFunction) this.paramFunction = param.paramFunction
            if (!isStrEmpty(param.nameFunctionClose)) this.nameFunctionClose = param.nameFunctionClose
            if (!isStrEmpty(param.textBtn)) this.textBtn = param.textBtn
            this.status = param.status
            this.titleLoading = param.titleLoading
            this.confirmLoading = param.confirmLoading
            this.loadingTransaction = param.loadingTransaction
        })

        EventBus.$on('hide-notications', () => {
            this.onClose()
        })
    },
    destroyed() {
        EventBus.$off('on-show-notications')
        EventBus.$off('hide-notications')
    },
    methods: {
        onConfirmOk() {
            if(this.confirmLoading){
                this.title = this.titleLoading
                this.loadingTransaction = true
            }else{
            this.dialog = false
            }
            EventBus.$emit(this.nameFunction, this.paramFunction)
        },
        onClose() {
            if (!isStrEmpty(this.nameFunctionClose)) {
                EventBus.$emit(this.nameFunctionClose)
                this.nameFunctionClose = ''
            }
            this.loadingTransaction = false
            this.dialog = false
            this.confirmLoading = false
        },
    },
    watch:{
       '$route'(){
        if(this.dialog){
            this.dialog = false
        }
       } 
    }
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/_notications.scss';
</style>
